import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { LoginService } from "../../services/login-service/login-service";
import { DataSharingService } from '../../services/login-service/data-sharing-service';
import { RESOLVED_TOKEN } from "../../app.tokens";
import { routingProviders } from "../../app.routing";

@Component({
  selector: 'app-collapse-navbar',
  providers: routingProviders,
  templateUrl: './collapse-navbar.component.html',
  styleUrls: ['./collapse-navbar.component.scss']
})

export class CollapseNavbarComponent implements OnInit {

  public isCollapsed = true;
  public locale_it = '';
  public locale_fr = '';
  public locale_de = '';
  public locale_en = '';
  public jwtToken: string;
  public username: string = '';
  public isAuthenticated = false;

  constructor(@Inject(LOCALE_ID) public locale: string,
              @Inject(RESOLVED_TOKEN) public localStorageToken: any,
              private dataSharingService: DataSharingService,
              private location: Location,
              private loginService: LoginService,
              private router: Router,
              private route: ActivatedRoute,
  ) {

    this.jwtToken = this.localStorageToken();
    //this.jwtToken = this.jwtToken.substring(1, this.jwtToken.length - 1);
    if (this.locale == 'it') {
      this.locale_it = 'active';
    }

    if (this.locale == 'fr') {
      this.locale_fr = 'active';
    }

    if (this.locale == 'en') {
      this.locale_en = 'active';
    }

    if (this.locale == 'de') {
      this.locale_de = 'active';
    }

    this.dataSharingService.isAuthenticated.subscribe( value => {
      this.isAuthenticated = value;
    });
  }

  ngOnInit() {
    const absoluteUrl = this.location.path().split('?')[0];
    let toTheTopAnchor = document.getElementById('to_the_top');
    if (toTheTopAnchor) {
      toTheTopAnchor.setAttribute("href", '/' + this.locale + absoluteUrl + '#start');
    }

    if (this.jwtToken.length > 0) {
      this.getUserName();
    }

    this.dataSharingService.getData()
      .subscribe({
        next: (token) => {
          if (token == 'logout') {
            this.logout();
          } else {
            if (token.length > 0) {
              this.jwtToken = token;
              this.getUserName();
            }
          }
        },
        error: (error) => {
          console.warn('failed to get data', error);
        }
      })
  }

  logout() {
    this.username = '';
    localStorage.removeItem('token');
    localStorage.removeItem('PROJECTS');
    this.isAuthenticated = false;
    this.dataSharingService.isAuthenticated.next(this.isAuthenticated);
    const queryParams = this.route.snapshot.queryParams;
    const redirect = queryParams['redirect'] || '/adminDouseiner1!';
    this.router.navigateByUrl(decodeURI(redirect));
  }

  getUserName() {
    if (this.username.length > 0 && this.isAuthenticated) {
      return this.isAuthenticated;
    }

    this.loginService.showApistart(this.jwtToken)
      .subscribe((data: any) => {
          data = data || [];
          this.username = data['code'] || '';
          this.username = data['token'] || this.username;
          if (this.username == '401') {
            this.username = 'Der Benutzername oder das Passwort sind ungültig' + "<br />\n";
            this.username = this.username + data['message'];

            this.isAuthenticated = false;
            localStorage.removeItem('token');
            const queryParams = this.route.snapshot.queryParams;
            const redirect = queryParams['redirect'] || '/adminDouseiner1!';
            this.router.navigateByUrl(decodeURI(redirect));
          } else {
            this.isAuthenticated = true;
            this.username = data['text'];
          }
        }
      );

    return this.isAuthenticated;
  }
}
